import React, { useState } from "react";

const experiences = [
    {
        company: "VML (formerly Fenom Digital, A Wunderman Thompson Company)",
        title: "Full-Stack Software Engineer",
        period: "April 2021 - Current",
        description: [
            {
                text: "Built and maintained high-traffic ecommerce storefronts (David Yurman, PacSun, Hot Topic) using Salesforce Commerce Cloud, JavaScript, React, and TypeScript, with a focus on performance, UX, and checkout optimization.",
                subpoints: [
                    "Led development of a gesture-based mobile zoom and PDP interaction system, improving product exploration and mobile engagement using custom touch-event derivation and panning logic.",
                    "Designed and implemented BOPIS (Buy Online, Pick Up In-Store) for Hot Topic, integrating real-time inventory/availability APIs and contributing to a measurable increase in checkout conversion."
                ]
            },
            {
                text: "Partnered closely with product owners and client stakeholders to translate requirements into technical solutions, maintaining a 90%+ on-time delivery rate across multiple concurrent projects." },
            { 
                text: "Integrated numerous third-party services (payment, analytics, fulfillment, personalization), extending platform capabilities and improving reliability across the checkout and cart flows." },
            {
                text: "Contributed to the successful delivery of 8+ international ecommerce launches, taking ownership of frontend architecture, performance tuning, and cross-team collaboration.",
                subpoints: [
                    "Served as the sole developer completing the Hot Topic rollout, independently driving development from feature buildout through QA, launch, and stabilization."
                ]
            }
        ]
    },
    {
        company: "App Academy",
        title: "Computer Science",
        period: "2019-2020",
        description: "Completed a highly selective, intensive 1,000-hour software engineering program (acceptance rate <3%), focused on full-stack web development. Developed multiple projects utilizing JavaScript, React, Ruby on Rails, and other modern technologies."
    },
    {
        company: "City College of San Francisco",
        title: "Architecture",
        period: "2011 - 2012",
        description: "Studied the fundamentals of architectural technology and design, which sparked my initial interest in design and software."
    },
    {
        company: "California State University, Chico",
        title: "Mechanical Engineering",
        period: "2008 - 2010",
        description: "Completed advanced coursework in mathematics, physics, and mechanical engineering, building a strong analytical and problem-solving foundation."
    },
];

function Experience() {
    const [openIdx, setOpenIdx] = useState(3);

    return (
        <div className="experience-container">
            <h2 className="experience-title">Journey to Software</h2>
            <div className="timeline">
                {experiences.map((exp, idx) => (
                    <div className="timeline-item" key={exp.company}>
                        <div className="timeline-line" />
                        <button
                            className={`timeline-node${openIdx === idx ? " open" : ""}`}
                            onClick={() => openIdx === idx ? setOpenIdx(null) : setOpenIdx(idx)}
                            aria-label={openIdx === idx ? "Collapse" : "Expand"}
                        >
                            {openIdx === idx ? "−" : "+"}
                        </button>
                        <div className={`timeline-content${openIdx === idx ? " expanded" : ""}`}>
                            <h3>{exp.company}</h3>
                            {openIdx === idx && exp.title && (
                                <>
                                    <div className="d-flex justify-content-between">
                                        <span className="title">{exp.title}</span>
                                        <span className="period">{exp.period}</span>
                                    </div>
                                    {Array.isArray(exp.description) ? (
                                        <ul>
                                            {exp.description.map((item, i) => (
                                                <li key={i}>
                                                    {item.text}
                                                    {item.subpoints && (
                                                        <ul>
                                                            {item.subpoints.map((sub, j) => (
                                                                <li key={j}>{sub}</li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>{exp.description}</p>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Experience;